module.exports = __webpack_public_path__ + "static/media/img-management-producers.3db207d4.jpg";